import { useTranslation } from "react-i18next";
const CompareBtn = (props) => {
    return (
        <div className={"review-refresh-v2-wrapper"}>
            <button
                className={`review-refresh-v2-btn`}
                onClick={() => {
                    props?.compare();
                }}
            >
                {/*<FontAwesomeIcon icon={faPenClip} />*/}
                {/*{t("reviewstartbtn")}*/}
                Compare
            </button>
        </div>
    );
};
export default CompareBtn;
